<ng-container *ngIf="!isExplicitContent && internalLink?.title">
    {{internalLink.title}}
</ng-container>
<ng-content></ng-content>
